var _mask, _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_529_7129",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0603 33.4004C29.0603 32.5845 29.5686 31.8663 30.2863 31.4782C33.8348 29.5594 36.25 25.769 36.25 21.4067C36.25 15.1069 31.2132 10 25 10C18.7868 10 13.75 15.1069 13.75 21.4067C13.75 25.65 16.0352 29.3521 19.4258 31.317C20.1471 31.7349 20.6549 32.4727 20.6549 33.3063C20.6549 34.454 21.5853 35.3844 22.733 35.3844H27.0763C28.172 35.3844 29.0603 34.4962 29.0603 33.4004Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 21.4067C34.75 25.2039 32.6494 28.4951 29.5728 30.1587L30.9998 32.7976C35.0202 30.6237 37.75 26.3341 37.75 21.4067H34.75ZM25 11.5C30.3653 11.5 34.75 15.9157 34.75 21.4067H37.75C37.75 14.2981 32.0611 8.5 25 8.5V11.5ZM15.25 21.4067C15.25 15.9157 19.6347 11.5 25 11.5V8.5C17.9389 8.5 12.25 14.2981 12.25 21.4067H15.25ZM20.1779 30.0191C17.2373 28.3151 15.25 25.1003 15.25 21.4067H12.25C12.25 26.1997 14.833 30.3891 18.6737 32.6148L20.1779 30.0191ZM27.0763 33.8844H22.733V36.8844H27.0763V33.8844ZM19.1549 33.3063C19.1549 35.2825 20.7569 36.8844 22.733 36.8844V33.8844C22.4137 33.8844 22.1549 33.6256 22.1549 33.3063H19.1549ZM18.6737 32.6148C19.024 32.8178 19.1549 33.1061 19.1549 33.3063H22.1549C22.1549 31.8393 21.2702 30.6521 20.1779 30.0191L18.6737 32.6148ZM27.0763 36.8844C29.0004 36.8844 30.5603 35.3246 30.5603 33.4004H27.5603C27.5603 33.6677 27.3436 33.8844 27.0763 33.8844V36.8844ZM29.5728 30.1587C28.4631 30.7588 27.5603 31.9358 27.5603 33.4004H30.5603C30.5603 33.2332 30.6741 32.9738 30.9998 32.7976L29.5728 30.1587Z",
    fill: "#475467",
    mask: "url(#path-1-inside-1_529_7129)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.1714,
    y1: 36.9429,
    x2: 27.5485,
    y2: 36.9429,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.9321,
    y1: 39.25,
    x2: 26.781,
    y2: 39.25,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.5fb3db444c0238f66bae1ca73f46a92a.svg";
export { ForwardRef as ReactComponent };